/* =========================
   CONTACT DATA (AUTHENTIC)
========================= */

export const contactInfo = {
  institute: 'Mantra Prayas Institute',
  tagline: 'Creating an impact through excellence in education',

  address: {
    line1: '08, Hemukalani Circle',
    line2: 'Sindhu Nagar',
    city: 'Bhilwara',
    state: 'Rajasthan',
    pincode: '311001',
    country: 'India'
  },

  phone: {
    primary: '+91 89828 45157',
    secondary: '+91 88393 54369',
    alternate: '+91 90244 26331'
  },

  email: {
    info: 'mantrajeeneet@gmail.com',
    contactForm: 'mantrajeeneet@gmail.com'
  },

  social: {
    facebook: 'https://www.facebook.com/share/16gzVPrbPj/?mibextid=wwXIfr',
    facebookMaths: 'https://www.facebook.com/share/1C81qWzyrn/?mibextid=wwXIfr',
    instagram: 'https://www.instagram.com/prayas_institute_iitjee_neet/',
    instagramMaths: 'https://www.instagram.com/mathematics_mantra_iit_jee?igsh=MWN0eWEwbHo4dHAwZA%3D%3D&utm_source=qr',
    twitter: 'https://twitter.com/mantra_prayas',
    linkedin: 'https://www.linkedin.com/in/prayas-institute-13831b232/',
    youtube: 'https://www.youtube.com/channel/UCO4AGHWrJF9byVPncMVqqAw',
    androidApp: 'https://play.google.com/store/apps/details?id=com.onlinetestpanel.prayas&pcampaignid=web_share',
    iosApp: 'https://apps.apple.com/in/app/mantra-prayas/id6742650800',
    onlineTestPortal: 'http://Prayas.onlinetestpanel.com'
  },

  support: {
    content: 'Counselling & enquiry assistance available'
  },

  map: 'https://www.google.com/maps?q=Hemukalani+Circle+Sindhu+Nagar+Bhilwara+311001&output=embed'
};
